module.exports = __webpack_public_path__ + "img/Camera Icon - charcoal.6f23cd67.svg";